// Words of «تمرکز این هفته» and «کارهای من» (docs/tasks/31-personal-focus.md). Every reason is a fact from the
// person's own tasks or a recorded status — never an invented risk.

export const RANGES = [
    {value: "week", label: "هفته", title: "تمرکز این هفته", phrase: "این هفته"},
    {value: "two_weeks", label: "دو هفته", title: "تمرکز دو هفته‌ی پیش رو", phrase: "این دو هفته"},
    {value: "month", label: "ماه", title: "تمرکز این ماه", phrase: "این ماه"},
];
export const rangeOf = (value) => RANGES.find((range) => range.value === value) || RANGES[0];

export const TYPE_LABEL = {milestone: "مایلستون", project: "پروژه", my_tasks: "کارهای من"};

export const STATUS = {
    late: {label: "کار عقب‌افتاده", severity: "danger"},
    due_in_range: {label: "موعد در این بازه", severity: "warning"},
    goal_risk: {label: "هدف در ریسک", severity: "danger"},
    open: {label: "در جریان", severity: "info"},
    no_tasks: {label: "بدون کار شما", severity: "secondary"},
};

export const GOAL_STATUS = {
    "on-way": "در مسیر",
    "has-risks": "در ریسک",
    "out-of-way": "خارج از مسیر",
    achieved: "محقق شده",
    canceled: "لغو شده",
};

export const PRIORITY = {
    high: {label: "بالا", severity: "danger"},
    medium: {label: "متوسط", severity: "warning"},
    low: {label: "عادی", severity: "secondary"},
};

const DAY = 24 * 60 * 60 * 1000;
const digits = (value) => new Intl.NumberFormat("fa-IR").format(value);

// "۱۰ آبان" for a "YYYY-MM-DD" day
export function faDay(day) {
    if (!day) return "";
    try {
        return new Intl.DateTimeFormat("fa-IR-u-ca-persian", {day: "numeric", month: "long"}).format(new Date(`${day}T12:00:00Z`));
    } catch {
        return day;
    }
}

// the Tehran day of a stored due date
export function tehranDay(value) {
    if (!value) return null;
    const time = Date.parse(value);
    if (!Number.isFinite(time)) return String(value).slice(0, 10);
    return new Date(time + 3.5 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

// «۲ روز تأخیر» / «امروز» / «فردا» / «۱۰ آبان»
export function dueText(dueDate, today) {
    const day = tehranDay(dueDate);
    if (!day) return "بدون موعد";
    const diff = Math.round((Date.parse(`${day}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / DAY);
    if (diff < 0) return `${digits(-diff)} روز تأخیر`;
    if (diff === 0) return "امروز";
    if (diff === 1) return "فردا";
    return faDay(day);
}

// «۲ کار به تو محول شده · ۱ عقب‌افتاده · ۱ با موعد در این بازه · هدف «…» در ریسک است»
export function reasonText(spotlight) {
    const facts = spotlight?.facts;
    if (!facts) return "";
    if (!facts.count) return spotlight.type === "milestone"
        ? "کاری از این مایلستون به تو محول نشده است."
        : spotlight.type === "project" ? "کاری از این پروژه به تو محول نشده است." : "کاری با موعد در این بازه نداری.";
    const parts = [`${digits(facts.count)} کار به تو محول شده`];
    if (facts.late) parts.push(`${digits(facts.late)} عقب‌افتاده`);
    if (facts.dueInRange) parts.push(`${digits(facts.dueInRange)} با موعد در این بازه`);
    const goalStatus = spotlight.goal?.goalStatus;
    if (goalStatus === "has-risks" || goalStatus === "out-of-way") parts.push(`هدف «${spotlight.goal.title}» ${GOAL_STATUS[goalStatus]} است`);
    return parts.join(" · ");
}

// پروژه · هدف · موعد · مسئول — only what the person may see
export function contextParts(spotlight) {
    if (!spotlight) return [];
    if (spotlight.type === "my_tasks") return ["فقط کارهای محول‌شده به خودت؛ رابطه‌ی پروژه و مایلستون عوض نمی‌شود"];
    const parts = [];
    if (spotlight.project?.title) parts.push(`پروژه: ${spotlight.project.title}`);
    if (spotlight.goal?.title) parts.push(`هدف: ${spotlight.goal.title}${GOAL_STATUS[spotlight.goal.goalStatus] ? ` (${GOAL_STATUS[spotlight.goal.goalStatus]})` : ""}`);
    if (spotlight.type === "milestone" && spotlight.lastDue) parts.push(`آخرین موعد کارها: ${faDay(spotlight.lastDue)}`);
    if (spotlight.type === "project" && spotlight.dueDate) parts.push(`موعد پروژه: ${faDay(spotlight.dueDate)}`);
    if (spotlight.type === "project" && spotlight.progress !== null && spotlight.progress !== undefined) parts.push(`پیشرفت ${digits(spotlight.progress)}٪`);
    if (spotlight.type === "milestone" && spotlight.owner) parts.push(`مسئول: ${spotlight.ownerIsMe ? "خودت" : spotlight.owner}`);
    return parts;
}

export const count = digits;
